import { IRegionInfo } from '../../types/region';
import { FAKE_RUSSIA_REGION } from '../../constants/fakeRegions';
import { TReduxActions } from '../../types/redux';
import { ERegionActionTypes } from '../../actions/region';

const DEFAULT_STATE: IRegionInfo = {
  currentRegion: FAKE_RUSSIA_REGION,
  regions: [],
  regionsByID: {},
  regionsABC: [],
  primalRegions: [],
};

export const regionInfoReducer = (state: IRegionInfo = DEFAULT_STATE, action: TReduxActions) => {
  switch (action.type) {
    case ERegionActionTypes.SetCurrentRegion:
      return {
        ...state,
        currentRegion: action.payload,
      };

    default:
      return state;
  }
};
